import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import Clock from '@icons/Clock';
import FavoriteAngularFill from '@icons/favorite/FavoriteAngularFill';
import { useState } from 'react';

import MenuShortcut from './MenuShortcut';
import MyMenus from './MyMenus';
import RecentOrders from './RecentOrders';
import styles from './styles.module.scss';

function QuickOrder() {
  const [isMyMenu, setIsMyMenu] = useState<boolean>(false);
  return (
        <section className={styles.container}>
            <div className={styles.wrapper}>
                <Text size='3xl' fontWeight='bold'>Quick Order</Text>
            </div>
            <Row spacing={8} justify='flex-end'
                 className={styles.wrapper}>
                <MenuShortcut icon={Clock} selected={!isMyMenu}
                              onClick={() => setIsMyMenu(false)} >
                    최근 주문
                </MenuShortcut>
                <MenuShortcut icon={FavoriteAngularFill} selected={isMyMenu}
                              onClick={() => setIsMyMenu(true)}>
                    MY메뉴
                </MenuShortcut>
                {/* <MenuShortcut icon={EditIcon}>편집</MenuShortcut> */}
                {isMyMenu && (
                    <Tooltip left={28}
                             visibleKey='myMenu'
                             className={styles.tooltip}
                             top={40}
                             align='left'
                             color={colors.gray9}
                             backgroundColor={colors.gray3}
                             right='unset'>
                        내가 좋아하는 메뉴를<br/>
                        한 번에 주문할 수 있어요
                    </Tooltip>
                )}
            </Row>
            {isMyMenu ? (<MyMenus/>) : (<RecentOrders/>)}
        </section>
  );
}

export default QuickOrder;
